import { z } from 'zod';
export const ShelfStatusSchema = z.enum([
    'wishlist',
    'reading',
    'done',
    'abandoned',
]);
export const ShelfEntrySchema = z.object({
    id: z.string().uuid(),
    userId: z.string().uuid(),
    bookId: z.string().uuid(),
    status: ShelfStatusSchema,
    currentPage: z.number().int().min(0).nullable(),
    rating: z.number().int().min(1).max(5).nullable(),
    notes: z.string().max(5000).nullable(),
    startedAt: z.string().datetime().nullable(),
    finishedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const AddToShelfInputSchema = z
    .object({
    bookId: z.string().uuid(),
    status: ShelfStatusSchema,
})
    .strict();
export const UpdateShelfEntryInputSchema = z
    .object({
    status: ShelfStatusSchema.optional(),
    currentPage: z.number().int().min(0).nullable().optional(),
    rating: z.number().int().min(1).max(5).nullable().optional(),
    notes: z.string().max(5000).nullable().optional(),
})
    .strict();
//# sourceMappingURL=shelf.schema.js.map